import React, { useEffect, useState } from "react";

export const usePagination = (totalItems) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const totalPages = Math.ceil(totalItems / pageSize);

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const onNextPage = (callback) => {
    if (currentPage < totalPages) {
      const page = currentPage + 1;
      setCurrentPage(page);
      callback(page);
      return;
    }
  };

  const onPrevPage = (callback) => {
    if (currentPage > 1) {
      const page = currentPage - 1;
      setCurrentPage(page);
      callback(page);
      return;
    }
  };

  useEffect(() => {
    const totalPages = Math.ceil(totalItems / pageSize);

    if (currentPage > totalPages) {
      setCurrentPage(totalPages || 1);
    }
  }, [totalItems, pageSize, currentPage]);

  return {
    currentPage,
    pageSize,
    totalPages,
    setPageSize,
    setCurrentPage,
    onPageChange,
    onNextPage,
    onPrevPage,
  };
};
